//combine all reducers

import { combineReducers } from "redux";
// import billingReducer from "./billing/billingReducer";
// import categoryReducer from "./category/categoryReducer";
// import countryReducer from "./country/countryReducer";
// import currencyReducer from "./currency/currencyReducer";
// import emailmessageReducer from "./emailmessage/emailmessageReducer";
// import messageimageReducer from "./emailmessage/messageimageReducer";
// import orderReducer from "./order/orderReducer";
// import paymentReducer from "./paymenttype/paymenttypeReducer";
// import permissionReducer from "./permission/permissionReducer";
// import productReducer from "./product/productReducer";
// import productdocumentReducer from "./productdocument/productdocumentReducer";
// import productrequestReducer from "./productrequest/productrequestReducer";
// import productreviewReducer from "./productreview/productreviewReducer";
// import productvariantReducer from "./productvariant/productvariantReducer";
// import roleReducer from "./role/roleReducer";
// import vendorsaleReducer from "./sale/vendorsaleReducer";
// import orderpaymentReducer from "./sale/orderpaymentReducer";
// import shippingaddressReducer from "./shippingaddress/shippingaddressReducer";
// import subcategoryReducer from "./subcategory/subcategoryReducer";
// import subscriptionReducer from "./subscription/subscriptionReducer";
// import usersubscriptionReducer from "./usersubscrption/usersubscriptionReducer";
// import subscriptionoptionReducer from "./subscriptionoption/subscriptionoptionReducer";
// import userReducer from "./user/userReducer";
// import vendorReducer from "./vendor/vendorReducer";
// import vendorpayaccountReducer from "./vendorpayaccount/vendorpayaccountReducer";
// import vendorpaymnetReducer from "./vendorpayment/vendorpaymentReducer";
// import vendorsocialmediaacountReducer from "./vendorsocialmediaaccount/vendorsocialmediaaccountReducer";
// import auth from './auth/authReducer'
// import error from './auth/errorReducer'

// import loadingReducer from './authentication/loadingReducer'

const rootReducer = combineReducers({
  // auth,
  // error,
//   user_auth: authenticationReducer,
//   cart:cartReducer
  // loading:loadingReducer,
  // billings: billingReducer,
  // categories: categoryReducer,
  // countries: countryReducer,
  // currencies: currencyReducer,
  // emails: emailmessageReducer,
  // messageimages: messageimageReducer,
  // orders: orderReducer,
  // payments: paymentReducer,
  // permissions: permissionReducer,
  // products: productReducer,
  // productdocuments: productdocumentReducer,
  // productrequests: productrequestReducer,
  // productreviews: productreviewReducer,
  // productvariants: productvariantReducer,
  // roles: roleReducer,
  // vendorsales: vendorsaleReducer,
  // orderpayments:orderpaymentReducer,
  // shippingaddresses: shippingaddressReducer,
  // subcategories: subcategoryReducer,
  // subscriptions: subscriptionReducer,
  // user_subscriptions: usersubscriptionReducer,
  // subscriptionoptions: subscriptionoptionReducer,
  // users: userReducer,
  // vendors: vendorReducer,
  // vendorpayaccounts: vendorpayaccountReducer,
  // vendorpaymentrecords: vendorpaymnetReducer,
  // vendorsocialmediaaccounts: vendorsocialmediaacountReducer
});

export default rootReducer;
